import {
  Button,
  DefaultPopoverTargetHTMLProps,
  Popover,
  PopoverClickTargetHandlers,
  PopoverHoverTargetHandlers,
  PopoverTargetProps
} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Dispatch} from "react";
import {SearchableSortDirection} from "../../../../generated/graphql";
import {AssignmentViewActions, ManifestSortOptions} from "../../../../providers/AssignmentViewReducer";
import ManifestSortMenu from "./ManifestSortMenu";
import {DEFAULT_POPOVER_MODIFIERS} from "../../../../constants/constants";

type ManifestMenuProps = {
  dispatch: Dispatch<AssignmentViewActions>;
  manifestSort: ManifestSortOptions;
  sortByColor: {
    enable: boolean;
    direction: SearchableSortDirection;
  };
};

const ManifestMenu = ({dispatch, manifestSort, sortByColor}: ManifestMenuProps) => {
  const renderSettingsPopoverTarget = ({
    ...targetProps
  }: PopoverTargetProps &
    PopoverHoverTargetHandlers<DefaultPopoverTargetHTMLProps> &
    PopoverClickTargetHandlers<DefaultPopoverTargetHTMLProps>) => {
    return (
      <Button
        {...targetProps}
        variant="minimal"
        icon={<FontAwesomeIcon icon={solid("ellipsis-vertical")} />}
        data-testid="viewchanger-button"
      />
    );
  };

  const renderSettingsPopoverContent = () => {
    return (
      <MenuContent>
        <ManifestSortMenu dispatch={dispatch} manifestSort={manifestSort} sortByColor={sortByColor} />
      </MenuContent>
    );
  };

  return (
    <Popover
      interactionKind="click"
      usePortal
      placement="bottom-end"
      content={renderSettingsPopoverContent()}
      renderTarget={renderSettingsPopoverTarget}
      minimal
      modifiers={DEFAULT_POPOVER_MODIFIERS}
    />
  );
};
export default ManifestMenu;

const MenuContent = styled.div`
  width: 187px;
`;
